
import { DLM_LABEL_WORKFLOW_CODES } from "../../../../_constants";
import { DLMApplication, DLMSiteApplication } from "../../../../_models";
import { getDLMWorkflowCode } from "../../../../_helpers";
import { IDOCLabelApplication, IDOCLabelItem, initDOCLabelItemValues, initDOCLabelSiteValues } from "./_models";
import { cloneDeep, filter, pick, pickBy } from "lodash";
import { isPopulatedArray, isValidString, processNoteValues } from "../../../../../../../components/helpers";

const DLMAPP_COMMON_FIELDS = [
  "model",                // "Model",
  "scdfProjectPlanNo",    // "SCDF Plan No",
  "labelSet",
  "hourRating",
  "poNO",
  "podo",                 // 1,
  'approvalAttachment',
  'doHolder',
  'poHolder',
  'caHolder',
  'labelRecord',
];


const DLMAPP_FILE_FIELDS = [
  'podo',
  'approvalAttachment',
  'doHolder',
  'poHolder',
  'caHolder',
  'labelRecord',
];

// const DLMAPP_FILE_ARRAY_FIELDS = [
//   'otherAttachments',
// ];


const DLM_SITE_COMMON_FIELDS = [
  'id',
  'projectName',
  'projectLocation',
  'bpNumber',
  'installerName',
  'clientRefNo',
  'otherReference'
]

const DLM_SITEDETAIL_FIELDS = [
  "id",
  'projectName',
  'projectLocation',
  "installerName",
  "bpNumber",             // Building Plan No, same as SCDF Plan No
  "clientRefNo",
  "otherReference",
  "prototypeTestReport",
  "trainingRecord",
  "methodOfStatement",
  "productConstructionDrawing",
  "sitePlanDrawing",
  "siteChecklist",
  "setscoROI",
];


const DLM_SITEDETAIL_FILES = [
  'prototypeTestReport',
  'trainingRecord',
  'methodOfStatement',
  'productConstructionDrawing',
  'sitePlanDrawing',
  'siteChecklist',
  'setscoROI',
];

const DLM_SITEITEM_FIELDS = [
  'id',
  'itemNo',
  'size',
  'quantity',
  'doorType',
  'visionPanel',
  'remarks'
];


const RESUBMIT_MODES = [
'resubmit',
'resubmit_site',
'edit',       // edit by DLM Admin
'edit_site',
'edit_app',   // edit by Applicant
];


const convertSiteApplication2DOCLabelSite = (data: DLMSiteApplication) => {

  let _convert = {
    ...cloneDeep(initDOCLabelSiteValues),
    ...pickBy(data, (value, key) => (value && DLM_SITE_COMMON_FIELDS.indexOf(key) > -1))
  }

  DLM_SITEDETAIL_FILES.forEach( fld => {
    //@ts-ignore
    if (data[fld] && data[fld]?.id) {
      //@ts-ignore
      Object.assign(_convert, { [fld]: data[fld].id, [`${fld}AttachmentName`] : data[fld].fileName});
    }
  })

  let _itemDetails: Array<IDOCLabelItem> = [];
  if (data.siteApplicationDetails && data.siteApplicationDetails.length > 0) {

    const _items = filter(data.siteApplicationDetails, o => (! o.deleted));
    _items.forEach( _det => {
      let _item = {
        ...cloneDeep(initDOCLabelItemValues),
        ...pickBy(_det, (value, key) => (value && DLM_SITEITEM_FIELDS.indexOf(key) > -1))
      }
      // revert door sizes
      if (_item.size) {
        const _check = _item.size.match(/(.*)\((F|L)\)(.*)\((F|L)\)/);
        if (_check && _check.length === 5) {
          Object.assign(_item, {
            [`size${_check[2].trim()}`]: _check[1].trim(),
            [`size${_check[4].trim()}`]: _check[3].trim()
          })
        }
      }
      _itemDetails.push(_item);
    })
  }

  Object.assign(_convert, {itemDetails: _itemDetails});

  return _convert;
}

const convertDLMApplication2Request = (init: IDOCLabelApplication, data: DLMApplication, requestMode?: string) => {

  const {
    dlmType, applicationCertificate, applicationType,
    siteApplications
  } = data;

  const { id: certID, productBrandString: productBrand} = applicationCertificate;

  const dlmTypeId = dlmType && dlmType?.id ? dlmType.id : 0;
  const dlmTypeCode = dlmType && dlmType?.type ? dlmType.type : '';

  const appType = getDLMWorkflowCode(data);

  let _response = {
    ...cloneDeep(init),
    requestId: data.id ? data.id : 0,
    appType,
    dlmTypeId: dlmTypeId ? dlmTypeId : 0,
    certID: certID ? certID : 0,
    productBrand,
    // restore info
    ...pick(data, ['model','projectName','projectLocation','scdfProjectPlanNo','hourRating','poNO']),
    ...pick(applicationCertificate, ['cocNumber','product','companyName']),
  }

  if (requestMode) {
    Object.assign(_response, {requestMode});
  }

  if (data.podo && data.podo.id) {
    Object.assign(_response, {podo: data.podo.id, podoAttachmentName : data.podo.fileName});
  }

  if (data?.labelSet && data?.labelSet?.id && data.labelSet.id > 0) {
    Object.assign(_response, { labelSet: data.labelSet.id });
  }

  if (data?.state && data?.state === 'Draft') {
    Object.assign(_response, { isDraft : true });
  }

  switch(applicationType) {
    case 'TYPE_SITEINSPECTION':
      if (dlmTypeCode === 'TYPE_DOC') {
        Object.assign(_response, {
          percentCompletion: data?.percentCompletion ? data.percentCompletion : 0,
          coverageArea : data?.coverageArea ? data.coverageArea : 0,
          unit: data?.unit ? data.unit : ''
        });
      } else if (dlmTypeCode === 'TYPE_LABEL') {
        Object.assign(_response, {
          totalLabelQuantity : data.totalLabelQuantity ? data.totalLabelQuantity : 0
        })
      }
      break;

    case 'TYPE_TRIGGERTEST':
      Object.assign(_response, {
        samplingLocation : data?.samplingLocation ? data.samplingLocation : 0
      })
      break;

    case 'TYPE_LABELREPLACEMENT':
      if (data.hasOwnProperty('otherAttachments') && data.otherAttachments.length > 0) {
        Object.assign(_response, {otherAttachments: data.otherAttachments.map(o => { return { id: o.id, name: o.fileName}} )});
      }
      if (data.hasOwnProperty('policeReport') && data.policeReport?.id) {
        Object.assign(_response, {policeReport: data.policeReport.id, policeReportAttachmentName : data.policeReport.fileName});
      }
      break;

    case 'TYPE_APPLICATION':
    default:
      if (appType === 'DOC') {
        Object.assign(_response, {
          sirSelected: data?.sirSelected ? data.sirSelected.map(o => o.id) : [],
          sirSelectedText: data?.sirSelectedText ? data.sirSelectedText : ''}
        );
      }

      if (appType === 'DOC' || appType === 'MandatoryDOC') {
        Object.assign(_response, {
          coverageArea : data?.coverageArea ? data.coverageArea : 0,
          unit: data?.unit ? data.unit : ''}
        );
      } else {
        Object.assign(_response, {
          totalLabelQuantity : data?.totalLabelQuantity ? data.totalLabelQuantity : 0,
          hourRating : data?.hourRating ? data.hourRating : '',
        })
      }

      DLMAPP_FILE_FIELDS.forEach( fld => {
        //@ts-ignore
        if (data.hasOwnProperty(fld) && data[fld]?.id) {
          //@ts-ignore
          Object.assign(_response, {[fld]: data[fld].id, [`${fld}AttachmentName`] : data[fld].fileName});
        }
      })
      if (data.hasOwnProperty('otherAttachments') && data.otherAttachments.length > 0) {
        Object.assign(_response, {otherAttachments: data.otherAttachments.map(o => { return { id: o.id, name: o.fileName}} )});
      }

      // revalidate required docs
      Object.assign(_response, { hasRequiredDocs:  (
        Math.sign(_response.approvalAttachment) +
        Math.sign(_response.doHolder) +
        Math.sign(_response.poHolder) +
        Math.sign(_response.caHolder) +
        Math.sign(_response.labelRecord)
      )});

      break;
  }


  let siteDetails = filter(siteApplications, o => (! o.deleted)).map(convertSiteApplication2DOCLabelSite);

  if (siteDetails.length === 0 && (! (appType === 'Label1b2'))) {
      siteDetails = [{
        ...cloneDeep(initDOCLabelSiteValues),
        projectName: _response.projectName,
        projectLocation: _response.projectLocation,
      }];
  }

  Object.assign(_response, {siteDetails});

  return _response;
}

const processDLMPayload = (values: IDOCLabelApplication, requestId: number, requestMode: string, appType: string, dlmTypeId: number, certID: number, dlmTypeCode: string) => {

  const { totalLabelQuantity, hourRating, percentCompletion, samplingLocation, coverageArea, unit, siteDetails } = values;


  let applicationType = 'TYPE_APPLICATION';
  switch(appType) {
    case 'SiteInspect':
      applicationType = 'TYPE_SITEINSPECTION';
      break;
    case 'TriggerTest':
      applicationType = 'TYPE_TRIGGERTEST';
      break;
    case 'LabelInspect':
      applicationType = 'TYPE_LABELINSPECTION';
      break;
    default:
      break;
  }

  let payload = {
    ...pickBy(values, (value, key) => value && DLMAPP_COMMON_FIELDS.includes(key)),
    id: requestId,
    applicationType,
    dlmType: dlmTypeId,
    applicationCertificate: certID,
  };

  if (values?.otherAttachments && isPopulatedArray(values.otherAttachments)) {
    Object.assign(payload, { otherAttachments : values.otherAttachments.map(o => o.id)});
  }

  // extract site details
  let dlmWebPhase0SitesModel: any[] = [];

  if (siteDetails && siteDetails.length > 0) {
    const _first = cloneDeep(siteDetails[0]);
    // add projectName, projectLocation, installerName
    DLM_SITE_COMMON_FIELDS.forEach( fld => {
      //@ts-ignore
      if (fld !== 'id' && _first.hasOwnProperty(fld) && _first[fld]) {
        if (fld === 'bpNumber') {
          //@ts-ignore
          Object.assign(payload, { scdfProjectPlanNo: _first[fld]});
        } else {
          //@ts-ignore
          Object.assign(payload, { [fld]: _first[fld]});
        }
      }
    })


    // upload multiple sites for label workflow codes
    const _details = (DLM_LABEL_WORKFLOW_CODES.includes(appType)) ? cloneDeep(siteDetails) : [_first];
    _details.forEach( obj => {

      let _details = pickBy(obj, (value, key) => (value && DLM_SITEDETAIL_FIELDS.indexOf(key) > -1));
      let _itemDetails: Array<any> = [];
      if (obj?.itemDetails && obj.itemDetails.length > 0) {
        _itemDetails = obj.itemDetails.map((itemrow, idx) => {
          return {
            ...pickBy(itemrow, (value, key) => (value && DLM_SITEITEM_FIELDS.indexOf(key) > -1)),
            itemNo: `${idx + 1}`,
            hourRating
          }
        });
      }
      Object.assign(_details, { dlmWebPhase0DetailsModels : _itemDetails});
      dlmWebPhase0SitesModel.push(_details);
    });

    Object.assign(payload, { dlmWebPhase0SitesModel });
  }

  if (['resubmit_site','edit_site'].includes(requestMode)) {
    let site = dlmWebPhase0SitesModel[0];
    let obj = {
      application : {
        id: requestId,
      },
      siteApplicationid : site.id,
      siteApplication : site
    };

    processNoteValues(values, obj);

    return obj;
  }


  switch (appType) {
    case 'DOC':
      if (values?.sirSelectedText && isValidString(values.sirSelectedText)) Object.assign(payload, { sirSelectedText : values.sirSelectedText});
      if (values?.sirSelected && isPopulatedArray(values.sirSelected))  Object.assign(payload, { sirSelected : values.sirSelected.map( o => parseInt(`0${o}`)) });
      Object.assign(payload, { coverageArea, unit, hourRating });
      break;

    case 'MandatoryDOC':
      Object.assign(payload, { coverageArea, unit, hourRating });
      break;

    case 'SiteInspect':
      if (dlmTypeCode === 'TYPE_DOC') {
        Object.assign(payload, { coverageArea, unit, percentCompletion });
      } else if (dlmTypeCode === 'TYPE_LABEL') {
        Object.assign(payload, { totalLabelQuantity });
      }
      break;

    case 'TriggerTest':
      Object.assign(payload, { samplingLocation });
      break;

    case 'LabelInspect':
      if (dlmTypeCode === 'TYPE_DOC') {
        Object.assign(payload, { coverageArea, unit, percentCompletion });
      } else if (dlmTypeCode === 'TYPE_LABEL') {
        Object.assign(payload, { totalLabelQuantity });
      }
      break;

    case 'Label5':
    case 'Label1b1':
    case 'Label1b2':
    case 'Label1b3':
      Object.assign(payload, { totalLabelQuantity, hourRating });
      break;

    default:
      break;
  }

  if (['resubmit','edit','edit_app'].includes(requestMode)) {
    let obj = { application: payload }

    processNoteValues(values, obj);
  
    return obj;
  }

  return payload;
}

export {convertDLMApplication2Request, RESUBMIT_MODES, processDLMPayload}